// Shared client-side vehicle suggestion — mirrors backend /pricing/vehicle-suggestion.
// Used by all booking forms (admin create, agency, public) so the suggestion
// updates instantly without a round-trip.

export function suggestVehicles(passengers, luggage = 0) {
  const p = Math.max(1, parseInt(passengers || 0) || 1);
  const l = Math.max(0, parseInt(luggage || 0) || 0);
  // Heavy luggage → ~1.5 bags ≈ 1 extra seat equivalent.
  const effective = Math.max(p, p + Math.max(0, Math.floor((l - p) / 2)));
  const n = effective;
  let label, vehicles;
  if (n <= 4) { label = "1 voiture (Eco)"; vehicles = [{ type: "eco", count: 1 }]; }
  else if (n <= 8) { label = "1 Van"; vehicles = [{ type: "van", count: 1 }]; }
  else if (n <= 11) { label = "1 Van + 1 voiture"; vehicles = [{ type: "van", count: 1 }, { type: "eco", count: 1 }]; }
  else if (n <= 16) { label = "2 Vans"; vehicles = [{ type: "van", count: 2 }]; }
  else if (n <= 19) { label = "2 Vans + 1 voiture"; vehicles = [{ type: "van", count: 2 }, { type: "eco", count: 1 }]; }
  else {
    const vanCount = Math.ceil(n / 8);
    label = `${vanCount} Vans`;
    vehicles = [{ type: "van", count: vanCount }];
  }
  return {
    passengers: p,
    luggage: l,
    effective,
    vehicles,
    label,
    heavy: effective > p,
  };
}
